import type { LoginFormState } from './login-page.types';

export const buildLoginArgs = (form: LoginFormState): [string, string] => [
  form.username,
  form.password,
];

export const updateLoginField = <K extends keyof LoginFormState>(
  form: LoginFormState,
  key: K,
  value: LoginFormState[K],
): LoginFormState => ({
  ...form,
  [key]: value,
});
